import { StepFooterButton } from './StepFooterButton'

export default StepFooterButton
